var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { computed, onMounted, inject, ref, unref } from "vue";
// TODO: support computed for "noFetch"
/**
 * composable user store wrapper
 * @param noFetch when true, the user will not be fetched from the server
 * @param fetchOnce when true, the user will only be fetched from the server if it is not already in the store
 * @returns currentUser computed
 */
export function useCurrentUser(noFetch = false, fetchOnce = false) {
    // TODO: add store typing
    const store = inject("store");
    const currentUser = computed(() => store.getters["user/currentUser"]);
    const currentFavorites = computed(() => store.getters["user/currentFavorites"]);
    onMounted(() => {
        if (!unref(noFetch) && !(Object.keys(currentUser).length > 0) && unref(fetchOnce)) {
            store.dispatch("user/loadUser");
        }
    });
    const addFavoriteTool = (toolId) => __awaiter(this, void 0, void 0, function* () {
        yield store.dispatch("user/addFavoriteTool", toolId);
    });
    const removeFavoriteTool = (toolId) => __awaiter(this, void 0, void 0, function* () {
        yield store.dispatch("user/removeFavoriteTool", toolId);
    });
    return { currentUser, currentFavorites, addFavoriteTool, removeFavoriteTool };
}
export function useCurrentTheme() {
    const store = inject("store");
    const currentTheme = computed(() => store.getters["user/currentTheme"]);
    function setCurrentTheme(theme) {
        store.dispatch("user/setCurrentTheme", theme);
    }
    return {
        currentTheme,
        setCurrentTheme,
    };
}
// temporarily stores tags which have not yet been fetched from the backend
const localTags = ref([]);
/**
 * Keeps tracks of the tags the current user has used.
 */
export function useUserTags() {
    const { currentUser } = useCurrentUser(true);
    const userTags = computed(() => {
        let tags;
        if (currentUser.value) {
            tags = [...currentUser.value.tags_used, ...localTags.value];
        }
        else {
            tags = localTags.value;
        }
        const tagSet = new Set(tags);
        return Array.from(tagSet).map((tag) => tag.replace(/^name:/, "#"));
    });
    const addLocalTag = (tag) => {
        localTags.value.push(tag);
    };
    return { userTags, addLocalTag };
}
